import React, { useCallback } from "react"

import Masonry from "react-masonry-component"
import { useResponsiveValue } from "@theme-ui/match-media"

const MasonryGrid = ({ children, isLarge = false, isFull = false }) => {
  const gutterWidth = useResponsiveValue([12, 24], {
    defaultIndex: 1,
  })

  const options = {
    gutterWidth,
    itemWidth: isLarge
      ? [`100%`, `calc(50% - ${gutterWidth / 2}px)`]
      : [
          `calc(50% - ${gutterWidth}px)`,
          `calc(33.33% - ${gutterWidth / 1.5}px)`,
        ],
    itemWidthFull: isLarge ? [`100%`, `50%`] : [`50%`, `33.33%`],
    itemPadding: isLarge ? [0, 2] : [2, 2],
  }

  const onRef = useCallback(ref => {
    if (ref) {
      window.addEventListener("tile-loaded", () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            ref.masonry.layout()
          })
        })
      })
    }
  }, [])

  return (
    <Masonry
      ref={onRef}
      options={{
        transitionDuration: 0,
        gutter: isFull ? 0 : gutterWidth,
        percentPosition: true,
        horizontalOrder: true,
      }}
      updateOnEachImageLoad
    >
      {children(options)}
    </Masonry>
  )
}

export { MasonryGrid }
